import React from 'react';
import { BanderaMX } from './PapelPicado';

// Franja tricolor (verde / blanco / rojo)
const Tricolor: React.FC = () => (
  <div className="w-full h-[6px] flex">
    <span className="flex-1 bg-[#006847]" />
    <span className="flex-1 bg-white" />
    <span className="flex-1 bg-[#ce1126]" />
  </div>
);

// Posiciones de los fuegos artificiales (left, top, tamaño, retraso)
const fuegos = [
  { left: '7%', top: '10%', size: 120, delay: '0s' },
  { left: '85%', top: '16%', size: 120, delay: '0.5s' },
  { left: '26%', top: '4%', size: 90, delay: '1s' },
  { left: '68%', top: '48%', size: 95, delay: '1.4s' },
  { left: '46%', top: '26%', size: 80, delay: '0.9s' },
];

// Banner de Fiestas Patrias — se muestra solo en septiembre (Mes Patrio)
const BannerPatrio: React.FC = () => {
  const now = new Date();
  if (now.getMonth() !== 8) return null; // 8 = septiembre

  return (
    <section className="w-full">
      <Tricolor />
      <div
        className="relative overflow-hidden py-4 px-4 text-center"
        style={{ background: 'linear-gradient(135deg, #04492e 0%, #05603c 50%, #04492e 100%)' }}
      >
        {/* Fuegos artificiales */}
        {fuegos.map((f, i) => (
          <span
            key={i}
            className="firework"
            aria-hidden="true"
            style={{ left: f.left, top: f.top, width: f.size, height: f.size, animationDelay: f.delay }}
          />
        ))}

        {/* Contenido */}
        <div className="relative z-10">
          <div className="flex items-center justify-center gap-2 sm:gap-3 flex-wrap">
            <span className="text-[clamp(1.3rem,3vw,2rem)]" aria-hidden="true">🎆</span>
            <BanderaMX />
            <h2
              className="text-[clamp(1.4rem,4vw,2.4rem)] font-extrabold text-white uppercase tracking-wide"
              style={{ textShadow: '2px 2px 6px rgba(0,0,0,0.55)' }}
            >
              ¡Viva México!
            </h2>
            <BanderaMX />
            <span className="text-[clamp(1.3rem,3vw,2rem)]" aria-hidden="true">🎆</span>
          </div>
          <p className="text-[clamp(0.95rem,2.2vw,1.25rem)] text-[#ff6d00] mt-1">
            Fiestas Patrias · 15 y 16 de Septiembre
          </p>
          <p className="text-[clamp(0.85rem,1.8vw,1.05rem)] text-white/90 mt-0.5">
            ¡Celebra el Mes Patrio con la mejor cochinita! 🎉
          </p>
        </div>
      </div>
      <Tricolor />
    </section>
  );
};

export default BannerPatrio;
